// eslint-disable-next-line no-restricted-imports
import { Overlay, Tooltip } from 'react-bootstrap';
import React, { useState, useRef } from 'react';

interface HoverableTooltipProps {
  id: string;
  content: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  placement?: string;
  disableTooltip?: boolean;
}

function HoverableTooltip({
  id,
  content,
  children,
  className,
  placement = 'right',
  disableTooltip,
}: HoverableTooltipProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  return (
    <>
      <span
        className={className}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onPointerEnter={() => setShowTooltip(true)}
        onPointerLeave={() => setShowTooltip(false)}
        ref={tooltipRef}
      >
        {children ?? (
          <i
            className={
              'fa fa-question-circle text-neutral-400 hover:text-neutral-500 transition-colors cursor-pointer'
            }
          />
        )}
      </span>
      <Overlay
        show={showTooltip && !disableTooltip}
        target={() => tooltipRef.current}
        placement={placement}
        onHide={() => setShowTooltip(false)}
      >
        <Tooltip
          id={`${id} break-words`}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onPointerEnter={() => setShowTooltip(true)}
          onPointerLeave={() => setShowTooltip(false)}
        >
          {content}
        </Tooltip>
      </Overlay>
    </>
  );
}

export default HoverableTooltip;
